import { RENDERER_TYPES } from "../../../../enums";

/** LinkedIn profile entries for the Profile section - only those with URLs are shown */
export const LINKEDIN_PROFILE_ENTRIES = [
  { urlField: "linkedIn", label: "Company", nameField: 'company' },
  { urlField: "founderLinkedInUrl", label: "Founder", nameField: "founderName" },
  { urlField: "coFounderLinkedInUrl", label: "Co-Founder", nameField: "coFounderName" },
];

const CLIENT_DETAILS_LABEL_VALUES = [
  { field: "email", label: "Email" },
  { field: "secondaryMembers", label: "Secondary Email", renderer: RENDERER_TYPES.MULTIPLE_TEXT_RENDERER },
  { field: "title", label: "Title" },
  { field: "timezone", label: "Timezone", renderer: RENDERER_TYPES.TIMEZONE },
  { field: "no_of_emp", label: "No of Emp." },
  { field: "funding", label: "Funding (in millions)", renderer: RENDERER_TYPES.AMOUNT },
  { field: "revenues", label: "Revenues", renderer: RENDERER_TYPES.AMOUNT },
  {
    field: "target_no_of_emp",
    label: "Targeted No of Emp.",
    renderer: RENDERER_TYPES.CHIP_LIST,
  },
  {
    field: "target_account",
    label: "Target Client Accounts",
    renderer: RENDERER_TYPES.CHIP_LIST,
  },
  {
    field: "target_industries",
    label: "Targeted Industries",
    renderer: RENDERER_TYPES.CHIP_LIST,
  },
  {
    field: "target_titles",
    label: "Targeted Titles",
    renderer: RENDERER_TYPES.CHIP_LIST,
  },
  { field: "budget", label: "Budget", renderer: RENDERER_TYPES.AMOUNT },
  {
    field: "licenseForMeeting",
    label: "License For Meeting",
  },
  { field: "viewAmbassadorThreshold", label: "Ambassador Threshold" },
  { field: "meetingThreshold", label: "Meeting Threshold" },
  {
    field: "viewNextBatchAmbassadorThreshold",
    label: "Next Batch Ambassador Threshold",
  },
];

export { CLIENT_DETAILS_LABEL_VALUES };
